export class Collection {
   /**
    *
    * ```ts
   import { Collection } from "design-system-ui-components"

   const grouped = Collection.groupByKey([
   {result: 1, date: "2002-12-01"},
   {result: 20, date: "2002-12-01"},
   {result: 2, date: "2002-12-05"}
   ], "date")

   "grouped" is:
   {
   "2002-12-01": [
      {
         result: 1,
         date: "2002-12-01"
      },
      {
         result: 1,
         date: "2002-12-01"
      },
      {
         result: 2,
         date: "2002-12-01"
      }
   ],
   "2002-12-05": [
      {
         result: 2,
         date: "2002-12-05"
      }
   ]
   }
   * ```
   * @param collection - Collection of objects
   * @param key - Key of the object you want to group
   * @returns Object with grouped data
   */
   static groupByKey(
      collection: Record<string, any>[],
      key: string
   ): Record<string, any> {
      return collection.reduce((hash, record) => {
         if (record[key] === undefined) return hash

         return Object.assign(hash, {
            [record[key]]: (hash[record[key]] || []).concat(record)
         })
      }, {})
   }

   /**
    *
    * ```ts
   import { Collection } from "design-system-ui-components"

   const data = [
   {result: 1, date: "2002-12-01"},
   {result: 20, date: "2002-12-01"},
   {result: 2, date: "2002-12-05"}
   ]
   Collection.sortByKey(data, "result", "DESC")

   "data" is:
   [
      {result: 20, date: "2002-12-01"},
      {result: 2, date: "2002-12-05"},
      {result: 1, date: "2002-12-01"}
   ]
   * ```
   * @param collection - Collection of objects
   * @param key - Key of the object you want to sort
   */
   static sortByKey(
      collection: Record<string, any>[],
      key: string,
      direction: "ASC" | "DESC"
   ) {
      function compare(a: any, b: any) {
         if (a[key] < b[key]) {
            return direction === "ASC" ? -1 : 1
         }
         if (a[key] > b[key]) {
            return direction === "ASC" ? 1 : -1
         }
         return 0
      }

      return collection.sort(compare)
   }
}
